export default "__VITE_ASSET__DY8W3UgJ__"